// Sinalização "chame o usuário de volta à aba" sem permissão nenhuma:
// prefixa o título da aba com a contagem de respostas não-lidas ("(2) ...").
//
// Mantém SEMPRE o favicon oficial da aplicação — não mexemos no ícone, porque
// substituir/restaurar o favicon via canvas é instável entre browsers (corria
// risco de o ícone ficar preso no estado de badge). O contador no título é
// confiável e reverte sozinho. Complementa a Notifications API (que cobre
// quando a aba está em segundo plano).

let baseTitle: string | null = null;
let lastCount = -1;

/** Atualiza o título da aba com a contagem de respostas não-lidas. */
export function setUnreadBadge(count: number) {
  if (typeof document === "undefined") return;
  // Captura o título base uma vez, removendo qualquer "(n) " que tenha
  // sobrado de um estado anterior.
  if (baseTitle === null) baseTitle = document.title.replace(/^\(\d+\)\s*/, "");
  if (count === lastCount) return;
  lastCount = count;

  document.title = count > 0 ? `(${count}) ${baseTitle}` : (baseTitle ?? document.title);
}
